import * as React from 'react';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import GenericSelect from './GenericSelect';
import { PartnerSourceData } from '../../types';

type Props = Omit<React.ComponentProps<typeof GenericSelect>, 'options'>;

const PartnerSelect: React.FC<Props> = props => {
    const { sourceData } = props.input.sourceProvider;
    const options = React.useMemo(
        () =>
            sourceData.map((data: PartnerSourceData) => {
                const location = [data.partnerState?.trim(), data.partnerCountry?.trim()].filter(Boolean).join(', ');

                return {
                    value: data.value,
                    title: data.text,
                    label: data.partnerName ? (
                        <span>
                            {data.partnerName}
                            {location && <Typography.Text type="secondary">{` · ${location}`}</Typography.Text>}
                        </span>
                    ) : (
                        data.text
                    )
                };
            }),
        [sourceData]
    );

    return <GenericSelect {...props} options={options} />;
};

export default observer(PartnerSelect);
